import React from 'react';

import { Icon } from 'components';

import playArrow from 'assets/svg/play-arrow.svg';
import './twitchPlayContainer.scss';

interface Props {
    onPlay: () => void;
}

const TwitchPlayContainer: React.FC<Props> = ({ onPlay }) => {
    return (
        <div styleName="container" onClick={onPlay}>
            <Icon glyph={playArrow} className="__app-Icon" />
        </div>
    );
};

export default TwitchPlayContainer;
